<template>
  <ConfirmDialog
    :model-value="confirmState.show"
    :title="confirmState.title"
    :message="confirmState.message"
    :confirm-label="confirmState.confirmLabel"
    :confirm-color="confirmState.confirmColor"
    :confirm-icon="confirmState.confirmIcon"
    :loading="confirmState.pending"
    @update:model-value="(v) => { if (!v) cancelConfirm() }"
    @confirm="acceptConfirm"
  />
</template>

<script setup>
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'
import { useConfirm } from '@/composables/useConfirm'

/**
 * Única instancia de confirmación de la app. Se monta en el layout; las páginas
 * llaman a `confirm()` de @/composables/useConfirm.
 */
const { confirmState, cancelConfirm, acceptConfirm } = useConfirm()
</script>
